import { ReactNode, useEffect, useState, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

type Props = { children: ReactNode; roles?: string[] };

export default function ProtectedRoute({ children, roles }: Props) {
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const rolesKey = useMemo(() => roles?.join(',') ?? '', [roles]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me');
        if (!res.ok) return setAllowed(false);
        const data = await res.json();
        if (!roles || roles.length === 0) return setAllowed(true);
        const userRoles: string[] = data.roles || [];
        setAllowed(roles.some(r => userRoles.includes(r)));
      } catch {
        setAllowed(false);
      }
    })();
  }, [rolesKey, roles]);

  if (allowed === null) return <div className="p-4 text-center text-sm text-muted-foreground">Loading...</div>;
  return allowed ? <>{children}</> : <Navigate to="/" replace />;
}
